import { render, staticRenderFns } from "./common-city-town-store.vue?vue&type=template&id=060b40c4&scoped=true"
import script from "./common-city-town-store.vue?vue&type=script&lang=js"
export * from "./common-city-town-store.vue?vue&type=script&lang=js"
import style0 from "./common-city-town-store.vue?vue&type=style&index=0&id=060b40c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060b40c4",
  null
  
)

export default component.exports